import { size } from '@styles/theme'
import styled from '@emotion/styled'

import { ToggleOptions, ToggleSection, ToggleTitle } from './SharedNearbyFilterComponents'
import { ToggleButton } from '@elements/form_elements/ToggleButton'
import { PiCarProfileFill, PiHouseLineFill } from 'react-icons/pi'
import { NearbyActiveIndicator } from './NearbyActiveIndicator'

const StyledToggleButton = styled(ToggleButton)`
  padding: ${size(2)};
`

const HostingAvailabilityFilterSection = ({ value, onChange, isInactive }) => {
  return (
    <ToggleSection>
      <ToggleTitle>
        Hosting Availability
        <NearbyActiveIndicator isActive={value instanceof Set && value.size > 0} />
      </ToggleTitle>
      <ToggleOptions style={{ filter: isInactive && 'grayscale(100%)' }} onChange={onChange}>
        <StyledToggleButton
          value='can_host'
          name='hostLocation'
          selected={value?.has?.('can_host')}
          onChange={(e) => onChange(e, 'hostLocation', 'can_host')}>
          🏠&nbsp;&nbsp;Can Host
        </StyledToggleButton>
        <StyledToggleButton
          value='can_travel'
          name='hostLocation'
          selected={value?.has?.('can_travel')}
          onChange={(e) => onChange(e, 'hostLocation', 'can_travel')}>
          🚙&nbsp;&nbsp;Can Travel
        </StyledToggleButton>
      </ToggleOptions>
    </ToggleSection>
  )
}

export { HostingAvailabilityFilterSection }
